import { useEffect } from "react"
import { useUIStore, useEmailStore } from "@store"
import notificationsData from "@src/@core/data/notifications.json"
import emailsData from "@src/@core/data/emails.json"

export const useInitializeData = () => {
  const { notifications, addNotification } = useUIStore()
  const { setEmails } = useEmailStore()

  useEffect(() => {
    // Initialize notifications if empty
    if (notifications.length === 0) {
      notificationsData.forEach((notification) => {
        addNotification({
          type: notification.type as any,
          title: notification.title,
          message: notification.message,
          isRead: notification.isRead,
          userId: notification.userId,
          legacyId: notification.legacyId,
          actionUrl: notification.actionUrl,
        })
      })
    }

    // Initialize emails
    setEmails(emailsData as any)
  }, [notifications.length, addNotification, setEmails])
}
